//init notes
export default function initNotes() {
    const activeClass = "active";
    const opener = document.querySelectorAll('a.footnote-link');
    const close = document.querySelectorAll('.note .close');

    opener.forEach(el => {
        //el.dataset.id = 'note-' + el.textContent.trim();
        el.setAttribute('aria-expanded', 'false');

        el.addEventListener('click', (e) => {
            const popup = document.querySelector(`#${e.target.dataset.id}`);
            const activeEl = document.querySelector(`[data-id^="note-"].${activeClass}`);
            const activePopup = document.querySelector(`.note.${activeClass}`);

            if (!popup) return;

            e.preventDefault();

            if (activeEl) {
                activeEl.classList.remove(activeClass);
                activeEl.setAttribute('aria-expanded', 'false');
            }
            if (activePopup) {
                activePopup.classList.remove(activeClass);
                activePopup.querySelector('.close').setAttribute('tabIndex', '-1');
            }

            e.target.classList.add(activeClass);
            e.target.setAttribute('aria-expanded', 'true');
            popup.classList.add(activeClass);
            popup.querySelector('.close').removeAttribute('tabIndex');

            const wHeight = window.innerHeight;
            const pHeight = popup.offsetHeight;
            const topVal = popup.computedStyleMap().get('top').value;
            const totalHeight = pHeight + topVal;

            if (pHeight > wHeight) {
                popup.style.top = '0px';
                popup.style['overflow-y'] = 'auto';
                popup.style['max-height'] = '100vh';
            } else if (totalHeight > wHeight) {
                popup.style.top = `${wHeight - totalHeight}px`;
            }
        })
    });

    close.forEach(elm => {
        elm.addEventListener('click', (e) => {
            e.preventDefault();
            e.target.setAttribute('tabIndex', '-1');
            e.target.closest('.note').classList.remove(activeClass);

            opener.forEach(el => {
                if (el.classList.contains(activeClass)) {
                    el.classList.remove(activeClass);
                    el.setAttribute('aria-expanded', 'false');
                }
            });
        });
    });
}

